import map from 'lodash/map';
import isUndefined from 'lodash/isUndefined';
import isBoolean from 'lodash/isBoolean';
import assign from 'lodash/assign';
import isPlainObject from 'lodash/isPlainObject';
import filter from 'lodash/filter';

import { FeaturesServiceModule } from 'services/access/features/features.service';
import { OnboardingServiceModule } from 'services/data/onboarding.service';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { OptimizelyServiceModule } from 'services/data/optimizely.service';

export const AppsServiceModule = angular
    .module('app.services.data.appsService', [
        FeaturesServiceModule,
        OnboardingServiceModule,
        OptimizelyServiceModule,
        LaunchDarklyServiceModule
    ]).service('appsService', (
        $http,
        $window,
        $q,
        featureService,
        onboardingService,
        optimizelyService,
        launchDarklyService
    ) => {
        let storeApps;

        return {
            getApps,
            getSortedApps,
            getPurchasedApps,
            installApp,
            uninstallApp,
            getHmac,
            getAppToken,
            getUninstalledFeaturedApps
        };

        function getStoreApps() {
            if (!storeApps) {
                return $http.get(`${process.env.BASE_API_URL}/marketplace/storeapps`).then((res) => {
                    storeApps = map(res.data, fixAppImageStructure);
                    return storeApps;
                });
            }
            return $q.resolve(storeApps);
        }

        function isFeatureFlagNotSetOrTurnedOn(allFeatureFlags, featureFlag) {
            if (isUndefined(allFeatureFlags) || isUndefined(allFeatureFlags[featureFlag])) {
                return true;
            }
            if (isBoolean(allFeatureFlags[featureFlag])) {
                return allFeatureFlags[featureFlag];
            }
            return !!allFeatureFlags[featureFlag];
        }

        function getApps() {
            return $q.all([getStoreApps(), featureService.getFeatures(), launchDarklyService.allFlags()])
                .then(([allApps, features, ldFlags]) => {
                    const filteredApps = filter(allApps, app => app.isAvailable
                        && isPlainObject(features[app.sku])
                        && isFeatureFlagNotSetOrTurnedOn(ldFlags, app.sku));
                    return map(filteredApps, app => assign(app, features[app.sku]));
                });
        }

        function getSortedApps(sortOrder) {
            return getApps().then((apps) => {
                return apps.sort((a, b) => {
                    let indexA = sortOrder.indexOf(a.sku);
                    let indexB = sortOrder.indexOf(b.sku);
                    if (indexA >= 0 && indexB >= 0) return indexA < indexB ? -1 : 1;
                    if (indexA >= 0 && indexB < 0) return -1;
                    if (indexA < 0 && indexB >= 0) return 1;
                    return 0;
                });
            });
        }

        function getHmac() {
            return $http.get(`${process.env.BASE_API_URL}/apps/hmac`)
                .then((hmac) => { return hmac.data; });
        }

        function getAppToken(appKey) {
            return $http.post(`${process.env.BASE_API_URL}/apps/token`, {}, {
                headers: {
                    'x-vol-app-key': appKey
                }
            })
                .then((token) => {
                    return token.data.token;
                });
        }

        function getPurchasedApps() {
            //This will have list of purchased App with app details.
            return getApps().then((allApps) => {
                return filter(allApps, { enabled: true });
            });
        }

        function getUninstalledFeaturedApps(count, sortOrder) {
            let unfilteredApps = sortOrder ? getSortedApps(sortOrder) : getApps();
            return unfilteredApps.then((allApps) => {
                const apps = filter(allApps, { enabled: false, isFeatured: true });
                return apps.slice(0, count);
            });
        }

        function installApp(app) {
            return featureService.enableFeature(app.sku).then(() => {
                onboardingService.completeTask('run.installApp');
                onboardingService.completeTask(`apps.${app.sku}_installed`);
                optimizelyService.trackEvent('action_complete');

                return getApps();
            });
        }

        function uninstallApp(app) {
            return featureService.disableFeature(app.sku).then(() => {
                return getApps();
            });
        }

        function fixAppImageStructure(app) {
            if (app.images[0] && app.images[0].logo) {
                app.logo = app.images[0].logo;
            }
            if (app.images[2] && app.images[2].icon) {
                app.icon = app.images[2].icon;
            }
            if (app.images[1] && app.images[1].app) {
                app.images = app.images[1].app;
            }
            return app;
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/apps.service.js